import { getStartParam } from './telegram';

export function reportIdFromStartParam(
  startParam?: string | null,
): string | null {
  if (!startParam) return null;
  const match = /^report[_-](.+)$/.exec(startParam);
  return match ? match[1] : null;
}

/* Convenience: the report id (if any) the Mini App was launched with. */
export function launchReportId(): string | null {
  return reportIdFromStartParam(getStartParam());
}
